export default __webpack_public_path__ + "static/SRUS P250 - Product Specifications & Technical Data-3904a0804f15fd1c338ffc0684af720b.pdf";